// extracted by mini-css-extract-plugin
module.exports = {"ResponsiveMedia":"ResponsiveMedia_ResponsiveMedia__3mJ5y","placeholder":"ResponsiveMedia_placeholder__3_dOg","placeHolderShimmer":"ResponsiveMedia_placeHolderShimmer__cK9IH"};